export enum RateType {
  Buy = 'BUY_RATE',
  Sell = 'SELL_RATE',
}
